import React, { useState, useEffect, useRef } from "react";
import strings from "../../Utils/strings";
import moment from "moment-timezone";
import constants from "../../Utils/constants";
import Widgets from "../../Widgets";
// import dashboardService from "../../services/dashboardService";
// import Request from "../../Assets/Images/request.png";
// import Appointment from "../../Assets/Images/appointmentColoured.png";
// import Leave from "../../Assets/Images/Leave.png";
// import Working from "../../Assets/Images/Working.png";
import { useNavigate } from "react-router";
import { t } from "i18next";
import toast from "react-hot-toast";
import utils from "../../Utils";
import { logDOM } from "@testing-library/react";
// import ClinicOnLeave from "../../Assets/Images/clinicOnLeave.png";
import classNames from "classnames";
import "./HospitalDashboard.css";
import clinicService from "../../Services/clinicService";
import calender from "../../Assets/Images/calender.png";
import authService from "../../Services/authService";
import "moment/locale/vi";
import { useSelector } from "react-redux";

function DashboardDetails(props) {
  const [appointmentRequestFilter, setAppointmentRequestFilter] = useState(false);
  const [appointmentFilter, setAppointmentFilter] = useState(false);
  const isRefresh = useSelector((state) => state.refreshNoti.refreshNoti);
  const nav = useNavigate();
  const [appointmentRequestBody, setAppointmentRequestBody] = useState(true);
  const [appointmentBody, setAppointmentBody] = useState(authService.getIsDoctorLogin() === "true" ?true:false);
  const [doctorAvailableBody, setDoctorAvailableBody] = useState(false);
  const [titles, setTitles] = useState(() => 
    authService.getIsDoctorLogin() === "true" ? "appointment" : "appointmentRequest"
);
  const [appointmentDetails, setAppointmentDetails] = useState([]);
  const [appointmentCount, setAppointmentCount] = useState(0);
  const [workingDoctorDetails, setWorkingDoctorDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [activeColumn, setActiveColumn] = useState(() =>   authService.getIsDoctorLogin() === "true"
    ? constants.dashboardType.appointment
    : constants.dashboardType.appointmentRequest)
  const [doctorLeaveDetails, setDoctorLeaveDetails] = useState([]);
  const [appointmentRequestDetails, setAppointmentRequestDetails] = useState([]);
  const [appointmentRequestCount, setAppointmentRequestCount] = useState("");
  const today = moment().format(constants.dateFormat.clinicDashboardDate);
  const tomorrow = moment().add(1, strings.miscellaneous.days).format(constants.dateFormat.clinicDashboardDate);
  const yesterday = moment().subtract(1, strings.miscellaneous.days).format(constants.dateFormat.clinicDashboardDate);

  const dateString = props.dateChange;
  const momentObj = moment(dateString, constants.dateFormat.dashboardformateDate);
  const formattedDate = momentObj.format(constants.dateFormat.clinicDashboardDate);
  const month = props.monthValue;
  const momentMonth = moment(month, constants.dateFormat.dashboardformateDate);
  const formattedMonth = momentMonth.format(constants.dateFormat.clinicDashboardDate);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [clinicLeaveDetailCount, setClinicLeaveDetailCount] = useState(0);
  const [appointmentPage, setAppointmentPage] = useState(1);
  let dateToSend = props.dateChange !== "" ? props.dateChange : props.monthChange;
  const [loadedPages, setLoadedPages] = useState([]);
  const [viewFilterList, setViewFilterList] = useState(utils.constants.dashboardCallType.callTypeFilterList.map((o) => ({ ...o })));
  const [viewAppointmentRequestCallType, setAppointmentRequestCallType] = useState(
    utils.constants.dashboardCallType.callTypeFilterList.map((o) => ({
      ...o,
    })),
  );

  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedLang, setSelectedLang] = useState("en");
  useEffect(() => {
    const savedLanguage = localStorage.getItem("i18nextLng") || "en";
    const lang = savedLanguage.startsWith("vi") ? "vi" : "en";
    setSelectedLang(lang);
  }, []);
  useEffect(() => {
    moment.locale(selectedLang);
  }, [selectedLang]);

  useEffect(() => {
    const handleDateOrMonthChange = async () => {
      setAppointmentPage(1);
      const dateOrMonth = props.dateChange || props.monthChange;
      const fetchFn = activeColumn === constants.dashboardType.appointmentRequest ? requestAppointments : getAppointments;

      await fetchFn(dateOrMonth);
      getDoctorAvailabilityDetails(dateOrMonth);
      setSelectedDate(dateOrMonth);
    };

    if (props.dateChange || props.monthChange) {
      handleDateOrMonthChange();
    }
  }, [props.dateChange, props.monthChange, activeColumn]);

  useEffect(() => {
    if (activeColumn === constants.dashboardType.appointmentRequest) {
      requestAppointments(props.dateChange);
    } else if (activeColumn === constants.dashboardType.appointment) {
      getAppointments(props.dateChange);
    } else if (activeColumn === constants.dashboardType.doctorAvailability) {
      getDoctorAvailabilityDetails(props.dateChange);
    }
  }, [appointmentPage]);

  useEffect(() => {
    setAppointmentPage(1);
    requestAppointments(props.dateChange);
    getAppointments(props.dateChange);
    getDoctorAvailabilityDetails(props.dateChange);
    setSelectedDate(props.dateChange);
  }, [props.dateChange]);

  useEffect(() => {
    setAppointmentPage(1);
    requestAppointments(props.monthChange);
    getAppointments(props.monthChange);
    getDoctorAvailabilityDetails(props.monthChange);
    setSelectedMonth(props.monthChange);
  }, [props.monthChange]);

  useEffect(() => {
    if (activeColumn === constants.dashboardType.appointmentRequest) {
      requestAppointments(props.dateChange, undefined);
    } else if (activeColumn === constants.dashboardType.appointment) {
      getAppointments(props.dateChange);
    }
  }, [appointmentPage]);

  useEffect(() => {
    setPage(1);
    getDashboardAppointments();
  }, [props.dateChange, titles]);

  useEffect(() => {
    if (authService.getIsDoctorLogin() === "false" && titles === "doctorAvailability") {
      getDoctorLeaveList();
    }
  }, [props.dateChange, titles]);

  useEffect(() => {
    setAppointmentPage(1);
    if (activeColumn === constants.dashboardType.appointment) {
      getAppointments(props.dateChange);
    } else if (activeColumn === constants.dashboardType.doctorAvailability) {
      getDoctorAvailabilityDetails(props.dateChange);
    } else {
      requestAppointments(props.dateChange);
    }
  }, [props.isCalenderChanged]);

  props.dashboardTitleChange(titles);
  const handleAppointment = () => {
    setAppointmentRequestBody(false);
    setAppointmentBody(true);
    setDoctorAvailableBody(false);
  };
  const handleAppointmentRequest = () => {
    setAppointmentRequestBody(true);
    setAppointmentBody(false);
    setDoctorAvailableBody(false);
  };
  const handleDoctorRequest = () => {
    setAppointmentRequestBody(false);
    setDoctorAvailableBody(true);
    setAppointmentBody(false);
  };
  const statuses = {
    appointmentRequest: ["WAITING_FOR_CLINIC_CONFIRMATION", "CONFIRMED"],
    appointment: ["SCHEDULED", "STARTED", "COMPLETED"],
    doctorAvailability: ["REJECTED"],
  };

  const toggleActive = (column) => {
    setAppointmentPage(1);
    //  let statusesToSend = constants.statuses[column];
    let statusesToSend = statuses[column];
    if (column === constants.dashboardType.appointmentRequest) {
      setTitles(constants.dashboardType.appointmentRequest);
      handleAppointmentRequest();
      requestAppointments(props.dateChange.statusesToSend);
      setActiveColumn(constants.dashboardType.appointmentRequest);
    } else if (column === constants.dashboardType.appointment) {
      setTitles(constants.dashboardType.appointment);
      handleAppointment();
      getAppointments(props.dateChange.statusesToSend);
      setActiveColumn(constants.dashboardType.appointment);
    } else if (column === constants.dashboardType.doctorAvailability) {
      setTitles(constants.dashboardType.doctorAvailability);
      handleDoctorRequest();
      getDoctorAvailabilityDetails(props.dateChange);
      setActiveColumn(constants.dashboardType.doctorAvailability);
    }
    setActiveColumn(column);
  };

  const formatteDate = (dateString) => {
    if (!dateString) {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }

    const [day, month, year] = dateString.split("-");
    return `${year}-${month}-${day}`;
  };

  const getDashboardAppointments = async (load) => {
    if(load !== "load"){
        // setIsLoading(true);
      }
    const apiParams = {
      appointmentRequest: ["WAITING_FOR_CLINIC_CONFIRMATION", "CONFIRMED"],
      appointment: ["SCHEDULED", "STARTED", "COMPLETED"],
      doctorAvailability: ["WAITING_FOR_CLINIC_CONFIRMATION", "CONFIRMED", "SCHEDULED", "STARTED", "COMPLETED"],
    };

    const selectedDate = formatteDate(props.dateChange);
    const selectedArray =
      titles === "appointmentRequest"
        ? apiParams.appointmentRequest
        : titles === "appointment"
          ? apiParams.appointment
          : titles === "doctorAvailability"
            ? apiParams.doctorAvailability
            : apiParams.appointmentRequest;
    try {
      let response;
      if (authService.getIsDoctorLogin() === "true") {
        response = await clinicService.docGetDashboardAppointments(selectedArray, selectedDate, page);
      } else if (authService.getIsDoctorLogin() === "false") {
        response = await clinicService.getDashboardAppointments(selectedArray, selectedDate, page);
      }
      if (response.status === "success") {
        setAppointments((prevAppointments) => {
          if (page === 1) {
            return response.data.appointments;
          } else {
            return [...prevAppointments, ...response.data.appointments];
          }
        });
        setAppointmentRequestCount(response.data.totalDocuments);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

    useEffect(() => {
      getDashboardAppointments("load");
    }, [isRefresh]);

  const requestAppointments = async (formattedDate, statuses) => {
    try {
      const body = {
        date: formattedDate || moment().format(constants.dateFormat.standardDate),
        filterBy: statuses,
      };

      // const response = await clinicService.getRequestedAppointments(
      //   body,
      //   appointmentPage
      // );
      let response;

      // Handle response and update state
      setAppointmentRequestDetails(response.data);
      setAppointmentRequestCount(response.data.length);
    } catch (error) {
      // Handle errors, e.g., display error messages to the user
      // console.error("Error fetching appointment requests:", error);
    }
  };

  const getAppointments = async (formattedDate, statuses) => {
    try {
      const body = {
        date: formattedDate || moment().format(constants.dateFormat.standardDate),
        filterBy: ["WAITING_FOR_CLINIC_CONFIRMATION", "CONFIRMED"],
      };

      // console.log(body)
      // const response = await clinicService.getAppointments(
      //   body,
      //   appointmentPage
      // );
      let response;

      // Handle response and update state
      setAppointments(response.data);
      setAppointmentCount(response.data.length);
    } catch (error) {
      // console.error("Error fetching appointments:", error);
    }
  };

  const getDoctorLeaveList = async () => {
    const selectedDate = formatteDate(props.dateChange);
    try {
      setIsLoading(true);
      let response;
      if (authService.getIsDoctorLogin() === "false") {
        response = await clinicService.getDoctorLeaveList(selectedDate);
      }
      if (response.status === "success") {
        setDoctorLeaveDetails(response.data.doctorsOnLeave);
        setWorkingDoctorDetails(response.data.doctors);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const getDoctorAvailabilityDetails = async (formattedDate) => {
    try {
      const date = formattedDate || moment().format(constants.dateFormat.standardDate);
      // const response = await clinicService.getDoctorAvailabilityDetails({
      let response;

      if (response && response.status) {
        setClinicLeaveDetailCount(response.clinicHoliday.length);
        setDoctorLeaveDetails(response.doctorsOnLeave);
        if (response.workingDoctorsData.length > 0) {
          setWorkingDoctorDetails(response.workingDoctorsData.map((details) => details.result));
        }
      }
    } catch (error) {
      // console.error("Error in getDoctorAvailabilityDetails:", error);
    }
  };
  const monthStartDate = props.dateChange !== "" ? moment(props.dateChange, constants.dateFormat.standardDate).format(constants.dateFormat.clinicDashboardDate) : "";

  const debounce = (func, delay) => {
    let timeoutId;

    return (...args) => {
      clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const handleScroll = debounce((event) => {
    let ele = event.target;
    if (Math.round(ele.scrollHeight - ele.scrollTop) - 1 <= ele.clientHeight) {
      setAppointmentPage(appointmentPage + 1);
    }
  }, 100);

  const handleLoadMore = () => {
    setPage((prevPage) => prevPage + 1);
  };

  useEffect(() => {
    getDashboardAppointments();
  }, [page]);

  return (
    <React.Fragment>
      {isLoading ? <Widgets.CircularLoader /> : ""}
      <div>
        <button type="button" className="btn btn-light today me-5" disabled>
          {props.dateChange
            ? monthStartDate
            : formattedDate == today
              ? strings.miscellaneous.today
              : formattedDate == yesterday
                ? strings.miscellaneous.yesterday
                : formattedDate == tomorrow
                  ? strings.miscellaneous.tommorow
                  : formattedDate == "Invalid date"
                    ? strings.miscellaneous.today
                    : formattedDate == formattedMonth
                      ? "Next Month"
                      : formattedDate}
        </button>
      </div>
      <table
        className={
          activeColumn == constants.dashboardType.appointmentRequest
            ? "table me-4 dashboard-table g-2"
            : activeColumn == constants.dashboardType.appointment
              ? "table me-4 dashboard-table-blue g-2"
              : activeColumn == constants.dashboardType.doctorAvailability
                ? "table me-4 dashboard-table-green g-2"
                : "table me-4 dashboard-table g-2"
        }
      >
        <thead className="dashboard-thead">
          <tr className="dashboard-table-tr col-12">
            { authService.getIsDoctorLogin() === "false" && <th className="dashboard-appointment col-1 custom-border-top">
              <div className="doctor-availability">
                <span
                  onClick={() => {
                    toggleActive(constants.dashboardType.appointmentRequest);
                    setAppointmentFilter(false);
                  }}
                  className={activeColumn === constants.dashboardType.appointmentRequest ? "active" : "head-appointment"}
                >
                  {t("appointmentRequests")} {titles === "appointmentRequest" && `(${appointmentRequestCount})`}
                </span>
                {appointmentRequestBody ? <div className="appointment-request-border"></div> : null}
              </div>
            </th>}
            <th className="dashboard-appointment col-1 custom-border-top">
              <div className="doctor-availability">
                <span
                  onClick={() => {
                    toggleActive(constants.dashboardType.appointment);
                    setAppointmentRequestFilter(false);
                  }}
                  className={activeColumn === constants.dashboardType.appointment ? "active" : "head-appointment"}
                >
                  {t("appointments")} {titles === "appointment" && `(${appointmentRequestCount})`}
                </span>
                {appointmentBody ? <div className="appointment-border"></div> : null}
              </div>
            </th>
            {authService.getIsDoctorLogin() === "false" && (
              <th className="col dashboard-doctor col-1 custom-border-top">
                <div className=" doctor-availability">
                  <span
                    onClick={() => toggleActive(constants.dashboardType.doctorAvailability)}
                    className={activeColumn === constants.dashboardType.doctorAvailability ? "active" : "head-appointment "}
                  >
                    {t("doctorAvailable")}
                  </span>
                  {doctorAvailableBody ? <div className="doctor-availability-border"></div> : null}
                </div>
              </th>
            )}
          </tr>
        </thead>
        {authService.getIsDoctorLogin() === "false" && activeColumn == constants.dashboardType.appointmentRequest && appointmentRequestBody ? (
          <tbody className="dashboard-tbody mt-1 col-12 custom-margin-top" onScroll={handleScroll}>
            {clinicLeaveDetailCount === 0 ? (
              <>
                <tr className="dashboard-table-tr doctor-work custom-tr-width">
                  <td>
                    <span className="patient">{t("hnNum")}</span>
                  </td>
                  <td scope="row">
                    <div className="d-flex">
                      <span className="patient">{t("patient")}</span>
                    </div>
                  </td>
                  <td className="patient-details">
                    <span className="patient">{t("PatientPhoneNo")}</span>
                  </td>
                  <td>
                    <span className="patient">{t("doctor")}</span>
                  </td>
                  <td>
                    <span className="patient">{t("time")}</span>
                  </td>
                  <td>
                    <span className="patient d-flex">{t("action")}</span>
                  </td>
                </tr>
                {appointments.length ? (
                  <>
                    {appointments.map((item, i) => {
                      return (
                        <tr className={`dashboard-table-tr custom-tr-width`} key={i}>
                          <td scope="row" className="custom-padding w-[12%]">
                            <div className="appointment-call-type">
                              <span className="patient-details text-nowrap" data-toggle="tooltip">
                                {item.hnNumber}
                              </span>
                            </div>
                          </td>
                          <td scope="row " className="custom-padding">
                            <div className="appointment-call-type ">
                              <span className="patient-details" title={item.patient.fullName}>
                                {/* {item.patientName} */}
                                {item.patient.fullName}
                              </span>
                            </div>
                          </td>
                          <td className="patient-details custom-padding">
                            <span className="patient-details  mt-1" data-toggle="tooltip" title={item.patient.phoneNumber}>
                              +{item.patient.countryCode} {item.patient.phoneNumber}
                            </span>
                          </td>
                          <td className="patient-details custom-padding">
                            <span className="patient-details  mt-1" data-toggle="tooltip" title={item.doctor.name}>
                              {item.doctor.name}
                            </span>
                          </td>
                          <td className="custom-padding">
                            <span className="patient-details mt-1">{moment(item.startTime).tz("Asia/Ho_Chi_Minh").format("LT")}</span>
                          </td>
                          <td className="btn-action">
                            <button
                              type="button"
                              className="btn btn-outline-danger detail mt-1"
                              onClick={() => {
                                const body = {
                                  appointmentDate: item.startTime,
                                  doctorId: item.doctor._id,
                                  appointmentId: item._id,
                                };
                                console.log(body,"body")
                                nav(strings.navigation.appointmentRequest, {
                                  state: body,
                                });
                              }}
                            >
                              {t("details")}
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                    {appointments.length === appointmentRequestCount ? null : (
                      <button className="load-more-btn" onClick={handleLoadMore} disabled={isLoading}>
                        {isLoading ? "Loading..." : "Load More"}
                      </button>
                    )}
                  </>
                ) : (
                  <div className="appointment-scroll">
                    <img className="request-img" src={calender} alt="text"></img>
                    <label className="request-text custom-font-weight">{t("noAppointmentRequest")}</label>
                  </div>
                )}
              </>
            ) : (
              <div className="appointment-scroll">
                <img className="request-img" src={calender} alt="text"></img>
                <label className="appointment-text">{t("dashboardClinicOnLeave")}</label>
              </div>
            )}
          </tbody>
        ) : null}

        {activeColumn == constants.dashboardType.appointment && appointmentBody ? (
          <tbody className="dashboard-tbody mt-1" onScroll={handleScroll}>
            {clinicLeaveDetailCount === 0 ? (
              <>
                <tr className="dashboard-table-tr doctor-work custom-tr-width">
                  <td>
                    <span className="patient">{t("hnNum")}</span>
                  </td>
                  <td scope="row">
                    <div className="d-flex">
                      <span className="patient">{t("patient")}</span>
                    </div>
                  </td>
                  <td className="patient-details">
                    <span className="patient">{t("PatientPhoneNo")}</span>
                  </td>
                  <td>
                    <span className="patient">{t("doctor")}</span>
                  </td>
                  <td>
                    <span className="patient">{t("time")}</span>
                  </td>
                  <td>
                    <span className="patient d-flex">{t("action")}</span>
                  </td>
                </tr>
                {/* {appointmentDetails && appointmentDetails.length > 0 ? ( */}
                {/* appointment.patient.name */}
                {appointments.length ? (
                  <>
                    {appointments.map((item, i) => {
                      // const formattedTime = moment(item.startTime).format(
                      //   "hh:mm A"
                      // );
                      // const dateArr = item.startTime.split("-");
                      // const date =
                      //   dateArr[2] + "-" + dateArr[1] + "-" + dateArr[0];
                      return (
                        <React.Fragment>
                          <React.Fragment>
                            <tr className="dashboard-table-tr custom-tr-width">
                              <td scope="row" className="custom-padding">
                                <div className="appointment-call-type">
                                  <span className="patient-details text-nowrap" data-toggle="tooltip">
                                    {item.hnNumber}
                                  </span>
                                </div>
                              </td>
                              <td scope="row" className="custom-padding">
                                <div className="appointment-call-type">
                                  <span className="patient-details" data-toggle="tooltip" title={item.patient.fullName}>
                                    {item.patient.fullName}
                                  </span>
                                </div>
                              </td>
                              <td className="patient-details custom-padding">
                                <span className="patient-details  mt-1" data-toggle="tooltip" title={item.patient.phoneNumber}>
                                  +{item.patient.countryCode} {item.patient.phoneNumber}
                                </span>
                              </td>
                              <td className="patient-details custom-padding">
                                <span className="patient-details  mt-1" data-toggle="tooltip" title={item.doctor.name}>
                                  {item.doctor.name}
                                </span>
                              </td>
                              <td className="custom-padding">
                                <>
                                  <span className="patient-details mt-1">{moment(item.startTime).tz("Asia/Ho_Chi_Minh").format("LT")}</span>
                                </>
                              </td>
                              <td className="btn-action">
                                <button
                                  type="button"
                                  className="btn btn-outline-danger detail mt-1"
                                  onClick={() => {
                                    const extraData = {
                                      appointmentDate: item.startTime,
                                      doctorId: item.doctor._id,
                                      appointmentId: item._id,
                                    };
                                    nav(strings.navigation.appointmentApprove, {
                                      state: extraData,
                                    });
                                  }}
                                >
                                  {t("attend")}
                                </button>
                              </td>
                            </tr>
                          </React.Fragment>
                        </React.Fragment>
                      );
                    })}
                    {appointments.length === appointmentRequestCount ? null : (
                      <button className="load-more-btn" onClick={handleLoadMore} disabled={isLoading}>
                        {isLoading ? "Loading..." : "Load More"}
                      </button>
                    )}
                  </>
                ) : (
                  <div className="appointment-scroll">
                    <img className="request-img" src={calender} alt="text"></img>
                    <label className="appointment-text">{t("noAppointmentsMsg")}</label>
                  </div>
                )}
              </>
            ) : (
              <div className="appointment-scroll">
                <img className="request-img" src={calender} alt="text"></img>
                <label className="appointment-text">{t("dashboardClinicOnLeave")}</label>
              </div>
            )}
          </tbody>
        ) : null}

        {activeColumn == constants.dashboardType.doctorAvailability && doctorAvailableBody && (
          <tbody className="mt-1">
            {workingDoctorDetails.length === 0 && doctorLeaveDetails.length === 0 ? (
              <div className="appointment-scroll">
                <img className="request-img" src={calender} alt="text"></img>
                <label className="appointment-text">{t("noDoctorAvailable")}</label>
              </div>
            ) : clinicLeaveDetailCount === 0 ? (
              <>
                <tr className="dashboard-table-tr doctor-work">
                  <th className="patient text-nowrap col-6">
                    <span className="working-header d-flex justify-content-center">
                      {t("working")} ({workingDoctorDetails && workingDoctorDetails.length})
                    </span>
                  </th>
                  <th className="patient text-nowrap col-6">
                    <span className="working-header d-flex justify-content-center">
                      {t("leave")} ({doctorLeaveDetails && doctorLeaveDetails.length})
                    </span>
                  </th>
                </tr>
                <tr>
                  <tr className={classNames(props.pendingAppointmentCount > 0 ? "doctor-working" : " doctor-working-details")}>
                    <td className="col-6 dashboard-doctor-tr border-right mt-1">
                      {workingDoctorDetails.length > 0 ? (
                        workingDoctorDetails.map((result, i) => {
                          let session = null;
                          if (result && result.doctorTimings && result.doctorTimings.timings) {
                            const arr = [];
                            result &&
                              result.doctorTimings &&
                              result.doctorTimings.timings &&
                              result.doctorTimings.timings.map((item, i) => {
                                if (item.isActive) {
                                  arr.push(i + 1);
                                }
                              });
                            session = arr.length > 0 ? arr.join(", ") : "";
                          }

                          const session_available = utils.strings.miscellaneous.workingSession;

                            return result ? (
                              <td
                                className="doctor-detail-work d-flex text-nowrap"
                                // onClick={() => {
                                //   nav(strings.navigation.manageDoctor, {
                                //     state: {
                                //       doctorId: result.doctorId,
                                //     },
                                //   });
                                // }}
                                onClick={() => {
                                  nav(
                                    utils.strings.navigation.doctorProfileView,
                                    {
                                      state: {
                                        doctorId: result._id,
                                      },
                                    }
                                  );
                                  authService.setDoctorID(result._id);
                                }}
                              >
                                <div>
                                  <div>
                                    <span className="me-4">
                                      {String(i + 1).padStart(2, "0")}.
                                    </span>
                                    <span
                                      className="doctor-name me-2"
                                      data-toggle="tooltip"
                                    >
                                      {result.name}
                                    </span>
                                  </div>
                                  {result.sessionCount > 0 ? (
                                    <div className="doctor-session">
                                      {`${t("workingSession")} (${
                                        result.sessionCount
                                      })`}
                                    </div>
                                  ) : null}
                                </div>
                              </td>
                            ) : null;
                          })
                        ) : (
                          <div className="col-12 doctor-all-doctor-available float-right">
                            <img
                              className="leave-img"
                              src={calender}
                              alt="text"
                            ></img>
                            <label className="leave-text text-nowrap">
                              {t("noDoctorAvailable")}
                            </label>
                          </div>
                        )}
                      </td>
                      <td className="col-6 dashboard-doctor-tr  mt-1">
                        {doctorLeaveDetails && doctorLeaveDetails.length > 0 ? (
                          doctorLeaveDetails.map((result, i) => {
                            return result ? (
                              <td
                                className="doctor-detail  text-nowrap d-flex ps-4 col-6"
                                onClick={() => {
                                  nav(strings.navigation.manageDoctor, {
                                    state: {
                                      doctorId: result.doctorId,
                                    },
                                  });
                                }}
                              >
                                <span className="me-4">
                                  {String(i + 1).padStart(2, "0")}.
                                </span>
                                <span
                                  className="doctor-name-leave me-2"
                                  data-toggle="tooltip"
                                  title={result.name[0]}
                                >
                                  {result.name[0]}
                                </span>
                              </td>
                            ) : null;
                          })
                        ) : (
                          <div className="col-12 doctor-all-doctor-available float-left">
                            <img
                              className="leave-img"
                              src={calender}
                              alt="text"
                            ></img>
                            <span className=" leave-text text-nowrap">
                              {t("allDoctorAvailable")}
                            </span>
                          </div>
                        )}
                      </td>
                    </tr>
                  </tr>
                </>
              ) : (
                <div className="appointment-scroll">
                  <img className="request-img" src={calender} alt="text"></img>
                  <label className="appointment-text">
                    {t("dashboardClinicOnLeave")}
                  </label>
                </div>
              )}
            </tbody>
          )}
      </table>
    </React.Fragment>
  );
}

export default DashboardDetails;
